export default "__VITE_ASSET__B13DkStM__"